import { createApp } from 'vue/dist/vue.esm-bundler';

import { createPinia } from 'pinia';

import Header from './twig/components/header/Header.vue';
import Footer from './twig/components/footer/Footer.vue';
import Cursor from './twig/components/cursor/Cursor.vue';
import Video from './twig/components/video/Video.vue';
import Accordion from './twig/components/accordion/Accordion.vue';
import Modal from './twig/components/modal/Modal.vue';
import ModalBtn from './twig/components/modal/ModalBtn.vue';
import Hero from './twig/components/hero/Hero.vue';
import CollageHero from './twig/components/collage-hero/CollageHero.vue';
import ArticleGrid from './twig/components/article-grid/ArticleGrid.vue';
import ImageCarousel from './twig/components/image-carousel/ImageCarousel.vue';

import './styles/styles.scss';

const pinia = createPinia();
const app = createApp({
  components: {
    Header,
    Footer,
    Cursor,
    Video,
    Accordion,
    Modal,
    ModalBtn,
    Hero,
    CollageHero,
    ArticleGrid,
    ImageCarousel
  },
});

app.use(pinia);
app.mount('#app');
